var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStopFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5EA2FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94493 3C4.43513 3 4.02185 3.41328 4.02185 3.92308V4.07692C4.02185 4.58672 4.43513 5 4.94493 5H15.0988C15.6086 5 16.0219 4.58672 16.0219 4.07692V3.92308C16.0219 3.41328 15.6086 3 15.0988 3H4.94493ZM4.17733 6C3.73043 6 3.33778 6.29652 3.21549 6.72636L2.36201 9.72636C2.18034 10.3649 2.65994 11 3.32385 11H3.5V16.0002C3.5 16.5524 3.94772 17.0002 4.5 17.0002H11.5C12.0523 17.0002 12.5 16.5524 12.5 16.0002V11H14.5V16.1214C14.5 16.6067 14.8933 17 15.3786 17H15.6214C16.1067 17 16.5 16.6067 16.5 16.1214V11H16.7338C17.3797 11 17.8561 10.3968 17.7066 9.76849L16.9927 6.76849C16.8855 6.31797 16.4829 6 16.0198 6H4.17733ZM5.50003 11.1664H10.5V15.1664H5.50003V11.1664Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopFill);
export default __webpack_public_path__ + "static/media/icon-stop-fill.6224aa0a507373f81340e8bd1d0ebabd.svg";
export { ForwardRef as ReactComponent };